import React, { useEffect, useState } from "react";
import { MainBodyContainer } from "../../widget/common/ui/MainContainer";
import AppTranslation from "../../service/app_translation/AppTranslation";
import { ResponsiveDeviceType } from "../../widget/layouts/ScreenMedia";
import DashboardLayout from "../dashboard/DashboardLayout";
import DashboardActions from "../dashboard/widget/DashboardActions";
import HomeContent from "./HomeContent";

const HomeScreen = () => {
  const type: number = ResponsiveDeviceType();
  const [height, setHeight] = useState(window.innerHeight);

  useEffect(() => {
    const handleResize = () => {
      setHeight(window.innerHeight);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <DashboardLayout
      title={type === 3 ? AppTranslation.text("home") : undefined}
      actions={type === 3 ? <DashboardActions navIndex={0} /> : undefined}
      navIndex={0}
      yCenter={false}
    >
      <MainBodyContainer
        className={`py-4 ${
          type === 1 && height > 780 ? "d-flex align-items-center" : ""
        }`}
      >
        <HomeContent type={type} />
      </MainBodyContainer>
    </DashboardLayout>
  );
};

export default HomeScreen;
export const routeName: string = "/home";
